import { useTranslation } from '../../i18n';
import { Badge } from '../ui/badge';

interface IBotStatusBadgeProps {
  status: string;
}

/** Tiny, pure status badge — reused by the list and detail screens. */
const BotStatusBadge = ({ status }: IBotStatusBadgeProps) => {
  const { t } = useTranslation();
  const isActive = status === 'active';

  return (
    <Badge variant={isActive ? 'success' : 'muted'}>
      {isActive ? t('bots.status.active') : t('bots.status.disabled')}
    </Badge>
  );
};

export default BotStatusBadge;
